const API_URL = process.env.NEXT_PUBLIC_MANAGE_HUB_MEMBER_API_URL;

export async function manageHubMember({ idToken, hubSlug, memberUid, memberDocId, action }) {
  if (!API_URL) {
    throw new Error("Manage hub member API is not configured.");
  }
  const body = {
    hubSlug,
    action,
  };
  if (memberUid) body.memberUid = memberUid;
  if (memberDocId) body.memberDocId = memberDocId;
  if (idToken) body.idToken = idToken;

  const resp = await fetch(API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

  let data = null;
  try {
    data = await resp.json();
  } catch {
    data = null;
  }

  if (!resp.ok) {
    const errorMsg = data?.error || "Request failed";
    throw new Error(errorMsg);
  }

  return data || { ok: true };
}
